export const HANDLE_LANGUAGE_CHANGE = 'handleLanguageChange';
